import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { AccessTime as TimeIcon, Info as InfoIcon } from '@mui/icons-material';

const SessionTimeoutTest = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <TimeIcon color="primary" />
          <Typography variant="h6" component="h2">
            Session Timeout Test
          </Typography>
        </Box>
        
        <Typography variant="body1" sx={{ mb: 2 }}>
          This page helps you test the session timeout functionality:
        </Typography>
        
        <Box component="ul" sx={{ pl: 2, mb: 3 }}>
          <Typography component="li" variant="body2" sx={{ mb: 1 }}>
            <strong>Inactivity Detection:</strong> The system tracks mouse movement, clicks, keyboard input, and scrolling
          </Typography>
          <Typography component="li" variant="body2" sx={{ mb: 1 }}>
            <strong>20-Minute Timer:</strong> After 20 minutes of inactivity, a warning dialog will appear
          </Typography>
          <Typography component="li" variant="body2" sx={{ mb: 1 }}>
            <strong>2-Minute Warning:</strong> You have 2 minutes to respond to the warning dialog
          </Typography>
          <Typography component="li" variant="body2" sx={{ mb: 1 }}>
            <strong>Auto Logout:</strong> If no response, you'll be automatically logged out
          </Typography>
        </Box>
        
        <Box sx={{ 
          p: 2, 
          backgroundColor: 'info.light', 
          borderRadius: 1,
          border: '1px solid',
          borderColor: 'info.main'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
            <InfoIcon color="info" />
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              Testing Instructions:
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ mb: 1 }}>
            1. Stop all activity (don't move mouse, click, or type)
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            2. Wait for 20 minutes (or modify the timer in useSessionTimeout.js for testing)
          </Typography>
          <Typography variant="body2">
            3. The warning dialog should appear with a 2-minute countdown
          </Typography>
        </Box>
        
        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Button 
            variant="outlined" 
            onClick={() => window.location.reload()}
            sx={{ mr: 2 }}
          >
            Refresh Page
          </Button>
          <Button 
            variant="contained" 
            onClick={() => {
              // Simulate user activity to reset timer
              document.dispatchEvent(new Event('mousemove'));
            }}
          >
            Simulate Activity
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default SessionTimeoutTest;
